import React from "react";
import { Stack, Typography } from "@mui/material";

interface FieldItemProps {
  label: string;
  value: string | number;
}

export const FieldItem: React.FC<FieldItemProps> = ({ label, value }) => {
  return (
    <Stack gap={3}>
      <Typography variant="inputLabel" sx={{ color: "#798397" }}>
        {label}
      </Typography>
      <Typography variant="body2">{value || "-"}</Typography>
    </Stack>
  );
};

export default FieldItem;
